module.exports = __webpack_public_path__ + "img/car.186a0854.png";